import {DashboardLayout, SearchInput, TableLayout} from 'components';
import CardSummary from 'components/CardSummary';
import React, {useState} from 'react';
import ReportedInvoiceModal from './components/ReportedInvoiceModal';
import {eye} from 'assets/images/images';

function ReportedInvoices() {
  const [invoiceDetails, setInvoiceDetails] = useState(false);

  const toggleInvoiceModal = () => setInvoiceDetails(prevState => !prevState);

  const tableHeader = [
    {label: 'Business name', key: 'name'},
    {label: 'IRN', key: 'irn'},
    {label: 'Amount', key: 'amount'},
    {label: 'VAT', key: 'vat'},
    {label: 'Transaction Date', key: 'transaction_date'},
    {label: 'Action', key: 'action'},
  ];

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Reported Invoices</p>
      }
    >
      <div className="flex items-center py-2 flex-wrap gap-3 justify-between mx-[-32px] px-8 border border-transparent border-b-[#E4E3EC]">
        <div className="flex items-center gap-2 flex-wrap">
          <SearchInput placeholder="Search here" />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 h-full my-6">
        <CardSummary title="Total Invoices" body="₦53,750" count="1" />
        <CardSummary title="Total Tax Accrued" body="₦3,750" />
      </div>
      <TableLayout negativeMargins>
        <thead className="font-semibold uppercase">
          <tr className="bg-white80">
            {tableHeader.map(({label, key}) => (
              <th
                key={key}
                className={`${
                  label === 'Business name' ? 'pl-4 sm:pl-6 xl:pl-8' : 'pl-0'
                } h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap`}
              >
                <div className="flex items-end gap-1 cursor-pointer">
                  <span>{label}</span>
                </div>
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody className="text-sm bg-white">
          <tr
            onClick={toggleInvoiceModal}
            className="border-[0.5px] border-[#E4E3EC] cursor-pointer"
          >
            <td className="p-4 pl-4 sm:pl-6 xl:pl-8 text-body whitespace-nowrap capitalize">
              Test Business
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              {' '}
              INV002123-94ND90NR-20250611
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">₦53,750</td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">₦3,750</td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              20th June, 2025
            </td>
            <td className="p-4 pl-0 whitespace-nowrap">
              <button title="View" className="h-4 aspect-square">
                <img src={eye} alt="View" />
              </button>
            </td>
          </tr>
        </tbody>

        <ReportedInvoiceModal
          show={invoiceDetails}
          onClose={toggleInvoiceModal}
        />
      </TableLayout>
    </DashboardLayout>
  );
}

export default ReportedInvoices;
